import React from "react"
import { Row, Col } from "react-bootstrap"
// import ExhibitionCard from "../../components/ExhibitionCard"
import Container from "../../components/Layout/Container"
import Wrapper from "../../components/Layout/Wrapper"
import { useExhibitionsActions } from "../../actions/useExhibitionsActions"
import { Loader } from "../../components/Layout/Loader"
import ExhibitionCardBigButton from "../../components/ExhibitionCardBigButton"

const ExhibitionsResults = ({ exhibitions, searchTerm }) => {
  const {
    exhibitions: paginatedExhibitions,
    loading,
    loadingMore,
  } = useExhibitionsActions(exhibitions, searchTerm, true)

  const Elements = () => {
    if (loading) {
      return <Loader />
    }

    return (
      <Row>
        {paginatedExhibitions.data.map(
          ({ id, description, image, thumbnail, date, title, author }) => (
            <Col xs={12} md={6} lg={4} key={id}>
              {/* <ExhibitionCard TODO: we'll go back to ExhibitionCard when we have more exhibitions (change lg={3})
                id={id}
                image={image}
                title={title}
                date={date}
                author={author}
                to={`/exhibitions/${id}`}
                href={"/exhibitions/[id]"}
              /> */}
              <ExhibitionCardBigButton
                id={id}
                image={thumbnail ?? image}
                name={title}
                author={author}
                date={date}
                to={`/exhibitions/${id}`}
                href={"/exhibitions/[id]"}
                cta="Visit"
              />
            </Col>
          ),
        )}
      </Row>
    )
  }

  return (
    <Container>
      <Elements />
      {loadingMore && <Loader />}
    </Container>
  )
}

export default ExhibitionsResults
